<template>
  <div class="c-requestsAdd">
    <div
      class="c-requestsAddPage"
      v-show="mode === 'add'"
    >
      <div class="c-requestsAdd_header">
        <search-breadcrumb
          :bread="bread"
          v-if="isPC"
        />
        <request-add-title />
      </div>

      <div class="c-requestsAdd_content">
        <div class="c-columns">
          <div class="c-columns_main">
            <request-add-contents
              @change-category="changeCategory"
              @change-detail="changeDetail"
              @change-price="changePrice"
              @change-date="changeDate"
              @change-remaining-count="changeRemainingCount"
              @change-input-values="changeInputValues"
            />
          </div>

          <div
            class="c-columns_side"
            v-if="isPC"
          >
            <request-add-navigation
              :is-valid-category="isValidCategory"
              :is-valid-detail="isValidDetail"
              :is-valid-price="isValidPrice"
              :is-valid-date="isValidDate"
              :remaining-count="remainingCount"
            />
          </div>
        </div>
      </div>

      <div class="c-requestsAdd_footer">
        <request-add-footer
          :remaining-count="remainingCount"
          :is-valid-all="isValidAll"
          @confirm="goToConfirm"
        />
      </div>
    </div>

    <div
      class="c-requestsConfirmPage"
      v-show="mode === 'confirm'"
    >
      <search-breadcrumb
        :bread="bread"
        v-if="isPC"
      />

      <div class="c-columns">
        <div class="c-columns_main">
          <div class="c-requestsConfirmPage_title">
            <span>依頼内容を確認</span>
            <span class="c-requestsConfirmPage_notice">
              <coconala-icon name="exclamation-circle" />
              まだ送信完了していません
            </span>
          </div>
          <request-detail-contents
            :request-detail="requestForConfirm"
            is-confirm
          />
        </div>

        <div class="c-columns_side">
          <request-add-confirm-buttons
            @submit="submitRequest"
            @back="goToAdd"
            :is-loading="isLoadingSubmit"
          />
        </div>
      </div>

      <div
        class="c-requestsConfirmPage_footer"
        v-if="!isPC"
      ></div>
    </div>

    <the-vueport breakpointType="vueportRequests" />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

import authenticated from '~/middleware/authenticated'

import SearchBreadcrumb from '~/components/molecules/SearchBreadcrumb'
import TheVueport from '~/components/organisms/TheVueport'
import RequestAddTitle from '~/components/organisms/RequestAddTitle'
import RequestAddContents from '~/components/organisms/RequestAddContents'
import RequestAddNavigation from '~/components/organisms/RequestAddNavigation'
import RequestAddFooter from '~/components/organisms/RequestAddFooter'
import RequestAddConfirmButtons from '~/components/organisms/RequestAddConfirmButtons'
import RequestDetailContents from '~/components/organisms/RequestDetailContents'

export default {
  name: 'RequestsAdd',
  middleware: ['redirectToContinueIfBusinessPreview', 'authenticated'],
  components: {
    SearchBreadcrumb,
    TheVueport,
    RequestAddTitle,
    RequestAddContents,
    RequestAddNavigation,
    RequestAddFooter,
    RequestAddConfirmButtons,
    RequestDetailContents
  },
  head() {
    return {
      title: '公開依頼をする | ココナラ',
      link: [{ rel: 'canonical', href: this.$route.path }],
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'ココナラは「知識・スキル・経験」など、みんなの得意を気軽に売り買いできるスキルマーケットです。友達に聞かれたり、お願いされるような「あなたの得意」を簡単出品。恋愛の相談から本格占い、キャッチコピー・ロゴ・イラスト作成まで何でも売り買いできます。'
        }
      ]
    }
  },
  data() {
    return {
      mode: 'add', // 'add' or 'confirm'
      bread: {
        type: 'request',
        breadcrumb: [
          {
            id: 999,
            url: '',
            isCurrent: true,
            name: '公開依頼を投稿'
          }
        ]
      },
      isValidCategory: false,
      isValidDetail: false,
      isValidPrice: false,
      isValidDate: false,
      remainingCount: 0,
      inputValues: {},
      requestForConfirm: [],
      isLoadingSubmit: false
    }
  },
  created() {
    this.setRequestForConfirm()
  },
  async mounted() {
    try {
      // 初期表示だけではAPIを投げないので、BigQueryのlog_actionを記録する専用のAPIを叩く
      // 二重送信防止でmounted
      // https://welself.atlassian.net/wiki/spaces/CD/pages/1400504507/API
      await this.$store.dispatch('big_query/log_action/addLogAction')
    } catch (e) {
      this.$sentry.captureException(e)
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP']),
    ...mapGetters('master', ['flattenMasterCategories']),
    ...mapState('master', ['requestItemsList']),
    isValidAll() {
      return this.isValidCategory && this.isValidDetail && this.isValidPrice && this.isValidDate
    }
  },
  methods: {
    changeCategory(isValid) {
      this.isValidCategory = isValid
    },
    changeDetail(isValid) {
      this.isValidDetail = isValid
    },
    changePrice(isValid) {
      this.isValidPrice = isValid
    },
    changeDate(isValid) {
      this.isValidDate = isValid
    },
    changeRemainingCount(remainingCount) {
      this.remainingCount = remainingCount
    },
    changeInputValues(inputValues) {
      this.inputValues = inputValues
    },
    goToConfirm() {
      this.setRequestForConfirm()
      this.mode = 'confirm'
      window.scroll(0, 0)
    },
    goToAdd() {
      this.mode = 'add'
      window.scroll(0, 0)
    },
    submitRequest() {
      this.isLoadingSubmit = true
      this.$store
        .dispatch('pages/requests/add/addRequestInformation', {
          params: this.inputValues
        })
        .then(response => {
          this.$router.push({ path: '/requests' }, () => {})
          this.$notify({
            group: 'flash',
            title: '依頼を投稿しました',
            text: response.message,
            type: 'success'
          })
        })
        .catch(result => {
          this.$notify({
            group: 'flash',
            title: result.message,
            type: 'error'
          })
          this.goToAdd()
          this.isLoadingSubmit = false
        })
    },
    setRequestForConfirm() {
      const masterCategory = this.flattenMasterCategories.find(
        masterCategory => masterCategory.id === this.inputValues.masterCategoryId
      )
      let masterCategoryId = 0
      let masterCategoryName = ''
      if (masterCategory) {
        masterCategoryId = masterCategory.id
        masterCategoryName = masterCategory.name
      }

      let deliveryDate = 0
      if (
        this.inputValues.deliveryDateYear &&
        this.inputValues.deliveryDateMonth &&
        this.inputValues.deliveryDateDay
      ) {
        const deliveryDateString =
          this.inputValues.deliveryDateYear +
          '/' +
          this.inputValues.deliveryDateMonth +
          '/' +
          this.inputValues.deliveryDateDay
        deliveryDate = this.$util.dayjs(deliveryDateString).unix()
      }

      const request = {
        title: this.inputValues.requestTitle,
        masterCategory: {
          id: masterCategoryId,
          name: masterCategoryName
        },
        outline: {
          priceMin: Number(this.inputValues.priceMin),
          priceMax: Number(this.inputValues.priceMax),
          withholdingFlag: this.inputValues.withholdingTaxFlag,
          expireDate: this.$util.dayjs(this.inputValues.expireDate).unix(),
          created: this.$util.dayjs().unix(),
          deliveryDate,
          applicationStatus: {
            offerCount: 0,
            contractCount: 0,
            viewCount: 0
          }
        },
        summariesList: [],
        detailsList: []
      }

      this.requestItemsList.forEach(requestItem => {
        if (requestItem.name === 'requestTitle') {
          // タイトルは別枠表示
          return
        }

        if (requestItem.title === '') {
          // タイトルがないものは他の項目に混ぜるため、単独の項目として表示しない
          return
        }

        let contentJson = []
        const inputValue = this.inputValues[requestItem.name]

        if (requestItem.name === 'targetAge') {
          // ターゲット像
          contentJson = this.buildTargetAgeContent(requestItem)
        } else if (inputValue) {
          if (requestItem.name === 'fileAttachment') {
            // 添付ファイル
            contentJson = inputValue
          } else if (requestItem.name === 'referenceUrl') {
            // 参考URL
            contentJson = this.buildReferenceUrlContent(requestItem)
          } else if (requestItem.displayStyle === 'range') {
            contentJson = this.buildRangeContent(requestItem)
          } else if (typeof inputValue === 'object') {
            // 複数選択フォーム
            contentJson = this.buildMultipleSelectionContent(requestItem)
          } else if (requestItem.selectItemsList.length > 0) {
            // 単一選択フォーム
            contentJson = this.buildSingleSelectionContent(requestItem)
          } else {
            // 自由入力フォーム
            contentJson = this.buildTextContent(requestItem)
          }
        }

        const item = {
          name: requestItem.name,
          title: requestItem.title,
          contentJson
        }

        if (requestItem.commonFlag) {
          request.detailsList.push(item)
        } else {
          request.summariesList.push(item)
        }
      })

      this.requestForConfirm = request
    },
    buildTargetAgeContent(requestItem) {
      const contentJson = []
      const inputValue = this.inputValues[requestItem.name]

      // targetAgeの分（複数選択）
      const content = {
        subTitle: requestItem.subTitle,
        values: []
      }
      if (inputValue) {
        content.values = this.buildMultipleSelectionContent(requestItem)
      }
      contentJson.push(content)

      // targetSexも混ぜる（単一選択）
      const combineRequestItem = this.requestItemsList.find(
        requestItem => requestItem.name === 'targetSex'
      )
      const combineInputValue = this.inputValues[combineRequestItem.name]
      const combineContent = {
        subTitle: combineRequestItem.subTitle,
        values: []
      }
      if (combineInputValue) {
        combineContent.values = this.buildSingleSelectionContent(combineRequestItem)
      }
      contentJson.push(combineContent)

      return contentJson
    },
    buildReferenceUrlContent(requestItem) {
      const contentJson = []
      const inputValue = this.inputValues[requestItem.name]

      // 空行を除いた配列を作る
      const urls = inputValue
        .replace('\r\n', '\n')
        .split('\n')
        .filter(url => {
          return url.length > 0
        })

      // 空行を除いたものでinputValuesを上書き
      this.inputValues[requestItem.name] = urls.join('\n')

      urls.forEach(url => {
        contentJson.push({ text: url })
      })

      return contentJson
    },
    buildRangeContent(requestItem) {
      const contentJson = []

      // スライダーをひとまとめにする
      const rangeRequestItems = this.requestItemsList.filter(
        rangeRequestItem => rangeRequestItem.displayStyle === 'range'
      )
      rangeRequestItems.forEach(rangeRequestItem => {
        const content = rangeRequestItem.optionJson || {}
        content.value = this.inputValues[rangeRequestItem.name]
        content.items = rangeRequestItem.selectItemsList.map(selectItem => selectItem.value)
        contentJson.push(content)
      })

      return contentJson
    },
    buildMultipleSelectionContent(requestItem) {
      const contentJson = []
      const inputValue = this.inputValues[requestItem.name]

      Object.keys(inputValue).forEach(key => {
        const selectItem = requestItem.selectItemsList.find(
          selectItem => selectItem.value === inputValue[key]
        )
        const content = selectItem.optionJson || {}
        content.label = selectItem.label || ''
        content.text = selectItem.otherFlag ? this.getOtherInputValue(requestItem) : ''
        contentJson.push(content)
      })

      return contentJson
    },
    buildSingleSelectionContent(requestItem) {
      const contentJson = []
      const inputValue = this.inputValues[requestItem.name]

      const selectItem = requestItem.selectItemsList.find(
        selectItem => selectItem.value === inputValue
      )
      const requestOption = requestItem.optionJson || {}
      const selectOption = selectItem.optionJson || {}
      const content = Object.assign(requestOption, selectOption)
      content.label = selectItem.label || ''
      content.text = selectItem.otherFlag ? this.getOtherInputValue(requestItem) : ''
      contentJson.push(content)

      return contentJson
    },
    buildTextContent(requestItem) {
      const contentJson = []
      const inputValue = this.inputValues[requestItem.name]

      const content = requestItem.optionJson || {}
      content.text = inputValue
      contentJson.push(content)

      return contentJson
    },
    getOtherInputValue(requestItem) {
      if (this.$util.hasPath(requestItem, 'optionJson.other.name')) {
        return this.inputValues[requestItem.optionJson.other.name] || ''
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-requestsConfirmPage {
  position: relative;
  margin: 0 auto;
  padding: 12px 20px 0;
  max-width: 1080px;

  .c-columns {
    display: flex;
    margin-top: 12px;

    justify-content: space-between;

    &_main {
      max-width: 688px;
    }
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-requestsConfirmPage {
    padding: 12px 0 0;
    max-width: 100%;
    font-size: 12px;

    &_title {
      margin-bottom: 12px;
      padding: 8px 12px 20px;
      border-bottom: 1px solid $color-gray-200;
      font-weight: bold;
      font-size: 18px;
    }

    &_notice {
      display: block;
      margin-top: 4px;
      color: $color-red-500;
      font-weight: normal;
      font-size: 12px;

      i {
        vertical-align: -1px;
      }
    }

    &_header {
      padding: 0 16px 16px;
      background-color: $color-white;
    }

    &_footer {
      padding-bottom: 60px;
      background-color: $color-gray-50;
    }

    .c-columns {
      flex-direction: column;
      margin-top: 0;
      background-color: $color-white;

      &_main {
        max-width: 100%;
      }
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-requestsConfirmPage {
    &_title {
      margin-bottom: 28px;
      font-weight: bold;
      font-size: 32px;
    }

    &_notice {
      margin-left: 4px;
      color: $color-red-500;
      font-weight: normal;
      font-size: 16px;

      i {
        font-size: 15px;
      }
    }

    .c-columns {
      margin-top: 24px;

      &_side {
        min-width: 300px;

        flex-basis: 300px;
      }

      &_main {
        margin-right: 52px;
        min-width: 0;

        flex-grow: 1;
      }
    }
  }

  .c-requestsAddPage {
    $content-max-width: 1000px;

    .c-requestsAdd {
      &_header {
        margin: 0 auto;
        padding: 8px 20px 24px;
        max-width: $content-max-width;
      }

      &_content {
        padding: 60px 0 40px;
        background-color: $color-bg-pale;
      }

      &_footer {
        margin: 0 auto;
        padding: 48px 20px 0;
        max-width: $content-max-width;
      }
    }

    .c-columns {
      display: flex;
      margin: 0 auto;
      padding: 0 20px;
      max-width: $content-max-width;

      &_main {
        flex: 0 1 728px;
      }

      &_side {
        flex: 0 0 200px;
        margin-left: 32px;
      }
    }
  }
}
</style>
